module.exports = __webpack_public_path__ + "fonts/DM_Sans-600-latin-ext12.0d3827b.woff2";